import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useNavigate } from 'react-router-dom';
import { api_url } from '../api/config/config';
import { Spinner } from 'react-bootstrap';

interface Report {
  year: string;
  month: string;
  file_name: string;
  file_path: string;
}

const Report: React.FC = () => {
  const [reports, setReports] = useState<Report[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);
  const { vendorInfo } = useSelector((state: RootState) => state.vendor);

  useEffect(() => {
    const fetchS3Reports = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${api_url}/getReports`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        })

        const res: any = await response.json();

        setReports(res.data);
      } catch (error) {
        console.error('Failed to fetch S3 reports:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchS3Reports();
  }, []);

  const handleUsageFileDownload = async (filePath: string, fileName: string) => {
    try {
      const response = await fetch(filePath);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("ファイルのダウンロードに失敗しました:", error);
    }
  };

  return (
    <>
      <section className="section-table-theme user-management">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10 mx-auto">
              <div className="login-wrapper pt-lg-5 pt-3 text-center">
                <img className="img img-fluid height-90 mb-2" src="assets/images/other/icon-report.svg" alt="Report Icon" />
                <div className="text-md mb-sm-4 mb-3 fw-400">レポート</div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-8 mx-auto">
            <div className="table-responsive overflow-y-unset fixed-header mb-lg-5 mb-4 tableFixHead">
              <table className="table table-borderless table-theme table-vertical-align-middle table-fixed">
                <thead>
                  <tr>
                    <th className="text-center w-min-170 fw-300">配信月</th>
                    <th className="text-center w-min-170 fw-300">データ</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={2} className="text-center py-5">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : reports && reports.length > 0 ? (
                    reports.map((report, index) => (
                      <tr key={index}>
                        <td className="text-center w-min-170 fw-300"><b>{report.year}年{report.month}月</b></td>
                        <td className="text-center w-min-170 fw-300 strong-red">
                          <a href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleUsageFileDownload(report.file_path, report.file_name);
                            }} className="download">
                            <img src="assets/images/other/icon-report-pdf.svg" alt="PDF Icon" /> &nbsp;{report.file_name}
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} className="text-center py-5">レポートがありません</td>
                    </tr>
                  )}
                  {/* {reports.map((r, index) => (
                    <tr key={index}>
                      <td className="text-center w-min-170 fw-300"><b>{r.Date.year}年{r.Date.month}月</b></td>
                      <td className="text-center w-min-170 fw-300 strong-red">
                        <a href="#" className="download" onClick={() => handleDownloadClick(r.Key, r.Name)}>
                          <img src="assets/images/other/icon-report-pdf.svg" alt="PDF Icon" /> &nbsp;{r.Name}
                        </a>
                      </td>
                    </tr>
                  ))} */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Report;